export const GOOGLE_MAPS_KEY = "AIzaSyCgwKgW7j7W7oa1MrAw3_iYPUOtWqUrD1Q";
export const GOOGLE_MAPS_MOBILE_KEY = "AIzaSyCsXHX6Yd2tY8Ppz2STVOUgCn79T5Ut0Rw";
export const GOOGLE_ANALYTICS_TRACKING_ID = "G-606Y7ZSBFV";
export const DEFAULT_ZOOM = 18;
export var OptimizationTarget;
(function(OptimizationTarget2) {
  OptimizationTarget2[OptimizationTarget2["Money"] = 0] = "Money";
  OptimizationTarget2[OptimizationTarget2["Green"] = 1] = "Green";
})(OptimizationTarget || (OptimizationTarget = {}));
export var InverterPrice;
(function(InverterPrice2) {
  InverterPrice2["Absolute"] = "Absolute";
  InverterPrice2["Relative"] = "Relative";
})(InverterPrice || (InverterPrice = {}));
export var MonthlyUsage;
(function(MonthlyUsage2) {
  MonthlyUsage2["Rupiah"] = "Rupiah";
  MonthlyUsage2["KWh"] = "KWh";
})(MonthlyUsage || (MonthlyUsage = {}));
export const powerOptions = [
  {name: "450 VA", value: 450},
  {name: "900 VA", value: 900},
  {name: "1.300 VA", value: 1300},
  {name: "2.200 VA", value: 2200},
  {name: "3.500 VA", value: 3500},
  {name: "3.900 VA", value: 3900},
  {name: "4.400 VA", value: 4400},
  {name: "5.500 VA", value: 5500},
  {name: "6.600 VA", value: 6600},
  {name: "7.700 VA", value: 7700},
  {name: "10.600 VA", value: 10600},
  {name: "11.000 VA", value: 11e3},
  {name: "13.200 VA", value: 13200},
  {name: "16.500 VA", value: 16500},
  {name: "23.000 VA", value: 23e3},
  {name: "33.000 VA", value: 33e3},
  {name: "41.500 VA", value: 41500},
  {name: "53.000 VA", value: 53e3}
];
export const CALCULATOR_SETTINGS = {
  plnSettings: {
    lowTariff: 1300,
    highTariff: 1444.7,
    lowTariffThreshold: 1300,
    energyTax: 0.1 + 0.05,
    minimalMonthlyConsumptionHours: 40,
    minimalMonthlyConsumptionPrice: 1500
  },
  priceSettings: {
    pricePerPanel: 7875e3,
    electricityPriceInflationRate: 0.05,
    priceOfInverterFactor: 0.1,
    priceOfInverterAbsolute: 8e6,
    installationCosts: 0,
    capacityLossRate: 75e-4,
    inverterPrice: InverterPrice.Relative,
    monthlyUsageType: MonthlyUsage.Rupiah
  },
  areaPerPanel: 2,
  inverterLifetimeInYears: 9,
  kiloWattPeakPerPanel: 0.45,
  kiloWattHourPerYearPerKWp: 1732,
  lossFromInverter: 0.9628,
  priorityEnabled: true
};
export const INITIAL_INPUT_DATA = {
  monthlyCostEstimateInRupiah: 1e6,
  monthlyUsageInKwh: 1e3,
  connectionPower: 7700,
  location: {location: {lat: -6.175456973926256, lng: 106.82712256908418}, address: ""},
  optimizationTarget: 0,
  calculatorSettings: CALCULATOR_SETTINGS
};
